import { subdomainListResp } from '@biz-models/network/account-model-network';
import {
	changePassword,
	subdomainLinkReq,
	subdomainLinkResp,
	subdomainUnlinkResp,
} from '@biz-models/network/login-authenticate-network.model';
import { TenantBasic } from '@biz-models/shared/current-user.model';
import { createActionGroup, emptyProps } from '@ngrx/store';

export const authenticationAccount = createActionGroup({
	source: 'Linked Account',
	events: {
		LoadSubdomainList: emptyProps(),

		LoadSubdomainListSuccess: (payload: subdomainListResp[]) => ({ payload }),

		LoadSubdomainListFail: (payload: string) => ({ payload }),

		LoadListAccount: (payload: any) => ({ payload }),

		UnlinkAccount: (payload: string) => ({ payload }),

		UnlinkAccountSuccess: (payload: subdomainUnlinkResp) => ({ payload }),

		LinkAccount: (payload: subdomainLinkReq) => ({ payload }),

		LinkAccountSuccess: (payload: subdomainLinkResp) => ({ payload }),

		ChangePassword: (payload: changePassword) => ({ payload }),

		ChangePasswordSuccess: (payload: any) => ({ payload }),

		ChangePasswordFail: (payload: any) => ({ payload }),

		LoginSubdomain: (payload: TenantBasic) => ({ payload }),

		LoginLinkedAccount: (payload: TenantBasic) => ({ payload }),
	},
});
